export default __webpack_public_path__ + "static/media/verified.a42bdedd.svg";